import {
  deleteFile,
  getJobFiles,
} from '@homeservices/api-kit/proreferral/files/v2';

import { uploadFiles } from '@/utils/file';

export default {
  state () {
    return {
      files: {},
    };
  },
  getters: {
    files (state) {
      return state.files;
    },
  },
  actions: {
    upload ({ commit }, { event }) {
      return uploadFiles(event).map((promise) => {
        return promise.then((response) => {
          commit('addFile', response.data);
          return response;
        });
      });
    },
    async delete ({ commit }, { id }) {
      await deleteFile(id);
      commit('removeFile', { id });
    },
    async getJobFiles ({ commit }, { id }) {
      const response = await getJobFiles(id, { size: 20 });
      response.data.results.forEach((fileIterator) => {
        commit('addFile', fileIterator);
      });
      return response;
    },
  },
  mutations: {
    addFile (state, data) {
      state.files = {
        ...state.files,
        [data.id]: data,
      };
    },
    removeFile (state, { id }) {
      const clone = { ...state.files };
      delete clone[id];
      state.files = clone;
    },
  },
};
